import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let map = new Map();
let loaded = false;
const subs = new Set();

export const refreshTeams = () => api.get("/teams/ids").then(({ data }) => {
  map = new Map(Object.entries(data).flatMap(([t, ids]) => ids.map((id) => [id, t])));
  subs.forEach((f) => f());
});
const load = () => {
  if (loaded) return;
  loaded = true;
  refreshTeams().catch(() => { loaded = false; });
  setInterval(() => document.visibilityState === "visible" && refreshTeams().catch(() => {}), 5 * 60 * 1000);
};
const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };

export const useTeamOf = (id) => useSyncExternalStore(subscribe, () => (id ? map.get(id) || null : null));
